"use client";




export default function InteriorBanner() {
  return (
    <div className="mt-20 w-full relative overflow-hidden">
      {/* Main banner container */}
      <div className="w-full relative py-20 px-4 lg:px-0 z-10">
        {/* Content container */}
        <div className="translate-x-0 w-full max-w-7xl mx-auto flex flex-col items-start gap-3">
          {/* Title */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white">
            Client Reviews
          </h1>
        </div>
      </div>
      {/* Background image and overlay */}
      <div className="absolute inset-0 w-full h-full z-0">
        {/* Gradient overlay */}
        <div className="absolute inset-0 z-10 bg-gradient-to-r from-black/70 dark:from-black/80 via-black/20 to-transparent" />

        {/* Background image */}
        <img
          src="/images/2aba8c470d030bc517b5ac6e48d2ea6d.jpg"
          className="w-full h-full object-cover"
          width={1280}
          height={568}
          fetchPriority="high"
          loading="eager"
        />
      </div>
    </div>
  );
}
